// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.consumer-stories-retail-lost-shoppers-qualtrics-slide-text-wrapper {
    .marked-list {
        list-style-type: disc;
        list-style-position: inside;
    }
}

.consumer-stories-retail-lost-shoppers-slide-image {
    width: min-content;
    height: min-content;
}

.upsell-carousel > .overflow-hidden:has(.consumer-stories-retail-lost-shoppers-qualtrics-slide) {
    .footer {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/slides/consumer-stories-retail-lost-shoppers-slide/ConsumerStoriesRLSSlide.css"],"names":[],"mappings":"AAAA;IACI;QACI,qBAAqB;QACrB,2BAA2B;IAC/B;AACJ;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".consumer-stories-retail-lost-shoppers-qualtrics-slide-text-wrapper {\n    .marked-list {\n        list-style-type: disc;\n        list-style-position: inside;\n    }\n}\n\n.consumer-stories-retail-lost-shoppers-slide-image {\n    width: min-content;\n    height: min-content;\n}\n\n.upsell-carousel > .overflow-hidden:has(.consumer-stories-retail-lost-shoppers-qualtrics-slide) {\n    .footer {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
